import {
  FETCH_USER_CONFIGURATIONS_START,
  FETCH_USER_CONFIGURATIONS_SUCCESS,
  FETCH_USER_CONFIGURATIONS_FAILURE,
  SEARCH_CITIES_SUCCESS,
  SEARCH_CITIES_FAILURE,
  SEARCH_CITIES_START,
  SEARCH_STATES_START,
  SEARCH_STATES_SUCCESS,
  SEARCH_STATES_FAILURE,
  SEARCH_LOCATIONS_START,
  SEARCH_LOCATIONS_SUCCESS,
  SEARCH_LOCATIONS_FAILURE,
} from '../actions/ActionConstant';

const initialState = {
  configurations: {
    data: {
      genders: [],
      countries: [],
      body_types: [],
      categories: [],
      ethnicities: [],
      relationship_status: [],
      smoking: [],
      drinking: [],
      annual_income: [],
      education: [],
      occupation: [],
      children: [],
      credit_score: []
    },
    loading: true,
    error: false,
  },
  cities: {
    data: [],
    inputData: {},
    loading: true,
    error: false,
  },
  states: {
    data: [],
    inputData: {},
    loading: true,
    error: false,
  },
  locations: {
    data: [],
    inputData: {},
    loading: true,
    error: false,
  },
};

const UserConfigurationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_CONFIGURATIONS_START:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          loading: true,
          error: false,
        },
      };
    case FETCH_USER_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        configurations: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_USER_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          loading: true,
          error: action.error,
        },
      };
    case SEARCH_CITIES_START:
      return {
        ...state,
        cities: {
          ...state.cities,
          inputData: action.data,
          loading: true,
        },
      };
    case SEARCH_CITIES_SUCCESS:
      return {
        ...state,
        cities: {
          ...state.cities,
          data: action.data,
          loading: false,
        },
      };
    case SEARCH_CITIES_FAILURE:
      return {
        ...state,
        cities: {
          ...state.cities,
          error: action.error,
          loading: false,
        },
      };
    case SEARCH_STATES_START:
      return {
        ...state,
        states: {
          ...state.states,
          inputData: action.data,
          loading: true,
        },
      };
    case SEARCH_STATES_SUCCESS:
      return {
        ...state,
        states: {
          ...state.states,
          data: action.data,
          loading: false,
        },
      };
    case SEARCH_STATES_FAILURE:
      return {
        ...state,
        states: {
          ...state.states,
          error: action.error,
          loading: false,
        },
      };
    case SEARCH_LOCATIONS_START:
      return {
        ...state,
        locations: {
          ...state.locations,
          inputData: action.data,
          loading: true,
        },
      };
    case SEARCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: {
          ...state.locations,
          data: action.data,
          loading: false,
        },
      };
    case SEARCH_LOCATIONS_FAILURE:
      return {
        ...state,
        locations: {
          ...state.locations,
          error: action.error,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default UserConfigurationsReducer;
